export const ORDER_SUMMARY_PREVIEW = [
  {
    name: 'Neckwear - Red Blue White Medallion - Silk Cotton Linen',
    image: 'img/images/tie.jpg',
    qty: 12,
    cost: 79.5
  },
  {
    name: 'Neckwear - Red Blue White Medallion - Silk Cotton Linen',
    image: 'img/images/tie.jpg',
    qty: 12,
    cost: 79.5
  },
  {
    name: 'Neckwear - Red Blue White Medallion - Silk Cotton Linen',
    image: 'img/images/tie.jpg',
    qty: 12,
    cost: 79.5
  },
  {
    name: 'Neckwear - Red Blue White Medallion - Silk Cotton Linen',
    image: 'img/images/tie.jpg',
    qty: 12,
    cost: 79.5
  },
  {
    name: 'Neckwear - Red Blue White Medallion - Silk Cotton Linen',
    image: 'img/images/tie.jpg',
    qty: 12,
    cost: 79.5
  },
  {
    name: 'Neckwear - Red Blue White Medallion - Silk Cotton Linen',
    image: 'img/images/tie.jpg',
    qty: 12,
    cost: 79.5
  },
  {
    name: 'Neckwear - Red Blue White Medallion - Silk Cotton Linen',
    image: 'img/images/tie.jpg',
    qty: 12,
    cost: 79.5
  }
]
